import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['Guía completa en formato digital (PDF)', 'Acceso inmediato después de la compra', 'Ejercicios prácticos en cada capítulo', 'Lista de señales de alerta (red flags)', 'Bonus: Checklist del Hombre de Alto Valor'];
export const Pricing: React.FC = () => {
  return <section id="precio" className="py-16 md:py-24 px-4 md:px-6 bg-cream" data-id="element-133">
      <div className="max-w-lg mx-auto text-center" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-135">
          <div className="w-12 h-px bg-gold mx-auto mb-8" data-id="element-136"></div>
          <h2 className="text-3xl md:text-4xl font-serif text-black mb-3" data-id="element-137">
            Obtén tu copia hoy
          </h2>
          <p className="text-charcoal-light font-light mb-10 text-sm md:text-base" data-id="element-138">
            Invierte en ti y en el amor que mereces.
          </p>

          <div className="bg-white border border-cream-dark shadow-sm p-6 md:p-10" data-id="element-139">
            <p className="text-xs uppercase tracking-widest text-rose font-bold mb-4" data-id="element-140">
              Oferta de lanzamiento
            </p>
            <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-141">
              <span className="text-charcoal-light line-through text-lg font-light" data-id="element-142">
                $14.99
              </span>
              <span className="text-4xl md:text-5xl font-serif text-black" data-id="element-143">
                $6.39
              </span>
              <span className="text-charcoal-light text-sm font-light" data-id="element-144">
                USD
              </span>
            </div>
            <p className="text-xs text-rose mb-8" data-id="element-145">
              Precio especial por tiempo limitado
            </p>

            <ul className="text-left space-y-3 mb-10" data-id="element-146">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-147">
                  <CheckIcon className="w-4 h-4 text-gold mt-0.5 flex-shrink-0" data-id="element-148" />
                  <span className="text-charcoal-light font-light text-sm md:text-base" data-id="element-149">
                    {item}
                  </span>
                </li>)}
            </ul>

            <motion.a href="https://mujercashflow.com/cart/46660218519742:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gold hover:bg-gold-dark text-white font-sans font-bold py-3.5 md:py-4 px-6 tracking-wide uppercase text-xs md:text-sm transition-colors duration-300 shadow-md text-center" data-id="element-150">
              Comprar ahora
            </motion.a>

            <p className="text-xs text-charcoal-light mt-4 font-light" data-id="element-151">
              Pago seguro · Descarga inmediata · Garantía de 30 días
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};